export default "/icons/react.svg";